"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePhoneNumber = exports.isPhoneValid = exports.validateAndSanitizePhone = exports.AllowedCountryCallingCodeMap = exports.AllowedCountryCodes = void 0;
var libphonenumber_js_1 = require("libphonenumber-js");
var types_1 = require("../types");
var codes_1 = require("../codes");
var AUSTRIA = types_1.Country.AUSTRIA, EGYPT = types_1.Country.EGYPT, KENYA = types_1.Country.KENYA, REUNION = types_1.Country.REUNION, MARTINIQUE = types_1.Country.MARTINIQUE, NETHERLANDS = types_1.Country.NETHERLANDS, NORWAY = types_1.Country.NORWAY, PORTUGAL = types_1.Country.PORTUGAL, SAINT_MARTIN = types_1.Country.SAINT_MARTIN, RUSSIAN_FEDERATION = types_1.Country.RUSSIAN_FEDERATION, SWEDEN = types_1.Country.SWEDEN, POLAND = types_1.Country.POLAND, CANADA = types_1.Country.CANADA, UNITED_STATES = types_1.Country.UNITED_STATES, QATAR = types_1.Country.QATAR, UNITED_ARAB_EMIRATES = types_1.Country.UNITED_ARAB_EMIRATES, SAUDI_ARABIA = types_1.Country.SAUDI_ARABIA, THAILAND = types_1.Country.THAILAND, CAPE_VERDE = types_1.Country.CAPE_VERDE, COTE_D_IVOIRE = types_1.Country.COTE_D_IVOIRE, UNITED_KINGDOM = types_1.Country.UNITED_KINGDOM, SWITZERLAND = types_1.Country.SWITZERLAND, ITALY = types_1.Country.ITALY, MONACO = types_1.Country.MONACO, LUXEMBOURG = types_1.Country.LUXEMBOURG, SPAIN = types_1.Country.SPAIN, BELGIUM = types_1.Country.BELGIUM, GERMANY = types_1.Country.GERMANY, FRANCE = types_1.Country.FRANCE;
/*
When adding a new country, or if a client doesn't receive his SMS, please check the geo-permissions on twilio.
By default all countries are disabled. Only the one currently in use have been activated.
https://console.twilio.com/?frameUrl=/console/sms/settings/geo-permissions
 */
exports.AllowedCountryCodes = new Set([
    AUSTRIA,
    EGYPT,
    KENYA,
    REUNION,
    MARTINIQUE,
    NETHERLANDS,
    NORWAY,
    PORTUGAL,
    SAINT_MARTIN,
    RUSSIAN_FEDERATION,
    SWEDEN,
    POLAND,
    CANADA,
    UNITED_STATES,
    QATAR,
    UNITED_ARAB_EMIRATES,
    SAUDI_ARABIA,
    THAILAND,
    CAPE_VERDE,
    COTE_D_IVOIRE,
    UNITED_KINGDOM,
    SWITZERLAND,
    ITALY,
    MONACO,
    LUXEMBOURG,
    SPAIN,
    BELGIUM,
    GERMANY,
    FRANCE,
]);
exports.AllowedCountryCallingCodeMap = Object.freeze(Array.from(exports.AllowedCountryCodes).reduce(function (acc, code) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[code] = (0, libphonenumber_js_1.getCountryCallingCode)(code), _a)));
}, {}));
var validateAndSanitizePhone = function (phoneInput, countryCode) {
    var phone = (0, libphonenumber_js_1.parsePhoneNumberFromString)(phoneInput, countryCode);
    if (!phone.isValid) {
        throw new Error(codes_1.PhoneErrors.NOT_VALID);
    }
    if (!exports.AllowedCountryCodes.has(phone.country)) {
        throw new Error(codes_1.PhoneErrors.NOT_SUPPORTED_COUNTRY);
    }
    return phone.number;
};
exports.validateAndSanitizePhone = validateAndSanitizePhone;
var isPhoneValid = function (phoneInput) {
    try {
        return !!(0, exports.validateAndSanitizePhone)(phoneInput);
    }
    catch (_a) {
        return false;
    }
};
exports.isPhoneValid = isPhoneValid;
var parsePhoneNumber = function (phoneInput) { return (0, libphonenumber_js_1.parsePhoneNumberFromString)(phoneInput); };
exports.parsePhoneNumber = parsePhoneNumber;
